import React, { useEffect, useContext } from "react";
import "./styles/Proyect.css";
import ScrollToTopOnMount from "../utilities/ScrollToTopOnMount";
import { useParams } from "react-router-dom";
import WorksContext from "../../Context/WorksContext";
import LinkButton from "../ui/LinkButton";
const Proyect = () => {
  const { seleccionarTrabajo, trabajoActivo } = useContext(WorksContext);

  let { id } = useParams();
  console.log(id);
  useEffect(() => {
    window.scrollTo(0, 0);
    seleccionarTrabajo(id);
  }, [id]);

  const trabajoRevisando = trabajoActivo[0];
  return (
    <>
      <ScrollToTopOnMount />
      <div className="c-proyect">
        <div className="proyect-header">
          <div className="proyect-header-img">
            <img src={trabajoRevisando.img} alt="" className=" img-fit" />
          </div>
          <h2 className="display-3 proyect-header-h2">
            {trabajoRevisando.nombre}
          </h2>
        </div>
        <ul className="proyect-list list">
          {trabajoRevisando.tecnologias.map((tec) => (
            <li className="list-item proyect-list-item">{tec}</li>
          ))}
        </ul>
        <div className="proyect-body">
          <p className="parrafo">{trabajoRevisando.descripcion}</p>
        </div>
        <div className="proyect-footer">
          <LinkButton to={`${trabajoRevisando.github}`} className="boton">
            GitHub
          </LinkButton>
          <LinkButton to={`${trabajoRevisando.url}`}>Live</LinkButton>
        </div>
      </div>
    </>
  );
};

export default Proyect;
